import { useInstantSearch, useClearRefinements } from "react-instantsearch-hooks-web";
import MessageXmark from "/packages/icons/message-xmark.svg";
import ArrowRotateLeft from "/packages/icons/arrow-rotate-left.svg";
import styles from "./NoResults.module.scss";

const includedAttributes = [
  "query",
  "category",
  "brand",
  "root_types",
  "feelings",
  "available_weights",
  "applicable_special_ids",
];

export default function NoResultsBoundary({ children }) {
  const { results, indexUiState } = useInstantSearch();
  const { canRefine, refine } = useClearRefinements({ includedAttributes });

  const showNoResults = !results.__isArtificial && results.nbHits === 0;

  if (showNoResults) {
    return (
      <div className={styles.no_results}>
        <MessageXmark style={{ fontSize: "3rem" }} />
        <span>
          {indexUiState.query ? (
            <>
              No products match your search: <q>{indexUiState.query}</q>
            </>
          ) : (
            "No products match your search criteria."
          )}
        </span>
        {canRefine && (
          <button className="button" data-type="basic" onClick={refine}>
            Reset Filters <ArrowRotateLeft />
          </button>
        )}
        <div hidden>{children}</div>
      </div>
    );
  }

  return <>{children}</>;
}